import React from "react";
import io from "socket.io-client";
import _ from "lodash";
import Config from "../../constants/config";

import { reduceList, reduceListExtra } from "./utils";
import { saveTokens } from "../store";
import { newCollectionItem } from "../../scheduler/index";

const base_url = "https://streamlabs.com/api/v1.0";

export const connectStreamLabs = () => {
  window.open(
    `${base_url}/authorize?response_type=code&client_id=${
      Config.streamlabs.client_id
    }&redirect_uri=${Config.streamlabs.redirect_uri}&scope=donations.read socket.token`,
    "streamlabs",
    "height=585,width=400"
  );
};

export const StreamlabsPopup = p => {
  return <div>Thanks for connecting</div>;
};

const getSocketToken = access_token => {
  return fetch(`${base_url}/socket/token?access_token=${access_token}`)
    .then(r => r.json())
    .then(r => r.socket_token);
};

const getDonations = access_token => {
  return fetch(`${base_url}/donations?access_token=${access_token}`)
    .then(r => r.json())
    .then(r => _.take(r.data, 10));
};

const parseDonation = d => {
  return {
    message: d.message,
    name: d.name,
    amount: parseFloat(d.amount)
  };
};

const typeDonation = d => {
  return {
    message: { type: "text", value: d.message },
    name: { type: "text", value: d.name },
    amount: { type: "number", value: d.amount }
  };
};

const notifyDonation = data => {
  const collName = "streamlabs.donations";
  newCollectionItem({
    item: {
      ..._.mapKeys(parseDonation(data), (v, k) => collName + "." + k),
      [collName + ".__id"]: data.id
    },
    collection: collName
  });
};

var listening = false;

const listenStreamlabs = token => {
  if (!listening) {
    getSocketToken(token).then(socket => {
      listening = true;
      const streamlabs = io(`https://sockets.streamlabs.com?token=${socket}`);
      streamlabs.on("event", data => {
        switch (data.type) {
          case "donation":
            notifyDonation(data.message[0]);
            break;
          default:
            console.log("Nothing to do for", data.type);
        }
      });
    });
  }
};

window.addEventListener(
  "message",
  e => {
    e.data.streamLabsToken && saveTokens("streamlabs", e.data.streamLabsToken);
  },
  false
);

export const sendCode = token => {
  window.opener.postMessage({ streamLabsToken: token }, window.location.origin);
  window.close();
};

const defaultDonations = [
  {
    message: "yoyo",
    name: "Example",
    amount: "5",
    donation_id: "streamlabs1244"
  },
  {
    message: "yoyo2",
    name: "FanClub",
    amount: "10",
    donation_id: "streamlabs112944"
  },
  {
    message: "You're welcome",
    name: "Huds.tv",
    amount: "100",
    donation_id: "streamlabs112945"
  }
];

const processDonations = (ds, cb) => {
  cb(
    {
      donations: reduceList(ds, "donation_id", true)
    },
    reduceListExtra(
      ds,
      "donation_id",
      _.flow([parseDonation, typeDonation]),
      "streamlabs.donations"
    )
  );
};

export default (params, id, cb) => {
  const access_token = _.get(params, "_tokens.streamlabs.access_token");
  if (access_token) {
    listenStreamlabs(access_token);
    getDonations(access_token).then(ds => processDonations(ds, cb));
  } else {
    processDonations(defaultDonations, cb);
  }
};



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/streamlabs.js